import { Component, OnInit } from "@angular/core";
import { AbstractControl, FormControl, FormGroup } from "@angular/forms";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { combineLatest } from "rxjs";
import { startWith, takeUntil } from "rxjs/operators";
import { UnsubscribeComponent } from "../../generals/Components";
import { ApiService } from "../../services/api.service";

@Component({
    selector: 'app-paymentmethodeditor',
    templateUrl: './paymentmethodeditor.component.html',
    styleUrls: ['./paymentmethodeditor.component.scss']
})
export class PaymentMethodEditorComponent extends UnsubscribeComponent implements OnInit {

    id: string = null;
    loading = true;
    formGroup: FormGroup = new FormGroup({
        info: new FormControl(null),
        netPrice: new FormControl(null),
        vatRate: new FormControl(null),
        grossPrice: new FormControl(null),
        enabled: new FormControl(null),
        isNet: new FormControl(true)
    });

    constructor(
        private config: DynamicDialogConfig,
        private ref: DynamicDialogRef,
        private apiService: ApiService
    ) {
        super();
        this.id = this.config.data.id;
    }

    ngOnInit(): void {
        this.load();
    }

    appendEvents(): void {
        this.formGroup.get('netPrice').valueChanges.subscribe((netPrice: number) => {
            const vatRate: number = this.formGroup.get('vatRate').value;
            this.formGroup.get('grossPrice').setValue(netPrice / 100 * (100 + vatRate), {
                emitEvent: false
            });
        });
        this.formGroup.get('grossPrice').valueChanges.subscribe((grossPrice: number) => {
            const vatRate: number = this.formGroup.get('vatRate').value;
            this.formGroup.get('netPrice').setValue(grossPrice / (100 + vatRate) * 100, {
                emitEvent: false
            });
        });
        this.formGroup.get('vatRate').valueChanges.subscribe((vatRate: number) => {
            const isNet: boolean = this.formGroup.get('isNet').value;
            if (isNet) {
                const netPrice: number = this.formGroup.get('netPrice').value;
                this.formGroup.get('grossPrice').setValue(netPrice / 100 * (100 + vatRate), {
                    emitEvent: false
                });
            } else {
                const grossPrice: number = this.formGroup.get('grossPrice').value;
                this.formGroup.get('netPrice').setValue(grossPrice / (100 + vatRate) * 100, {
                    emitEvent: false
                });
            }
        });
    }

    load(): void {
        if (this.id !== null) {
            this.apiService.getPaymentMethod(this.id).pipe(takeUntil(this.unsubscribe)).subscribe(({paymentmethodEditor}) => {
                this.formGroup.patchValue(paymentmethodEditor);
                this.appendEvents();
            }).add(() => {
                this.loading = false;
            });
        }
    }

    save(): void {
        this.apiService.updatePaymentMethod(this.id, this.formGroup.getRawValue()).pipe(takeUntil(this.unsubscribe)).subscribe(() => {
            this.close(true);
        });
    }

    close(result: boolean = false): void {
        this.ref.close(result);
    }
}
